import React from 'react';
import { useTranslation } from 'react-i18next';
import { CAL_BOOKING_URL } from '../config/calBookingUrl';
import { trackEvent, trackGoal } from './Matomo';
import './Contact.css';

function Contact() {
  const { t } = useTranslation();

  const trackBookingClick = () => {
    trackEvent('Booking', 'Click', 'Contact section');
    trackGoal(1);
  };

  return (
    <section id="contact" className="contact section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{t('contact.title')}</h2>
          <p className="section-subtitle">{t('contact.subtitle')}</p>
        </div>

        <div className="contact-cta">
          <a
            href={CAL_BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary"
            onClick={trackBookingClick}
          >
            {t('contact.cta')}
          </a>
        </div>
      </div>
    </section>
  );
}

export default Contact;
